module.exports = __webpack_public_path__ + "img/leaf.e51374fe.png";